export default __webpack_public_path__ + "static/media/assorted-clump.a8456c74.png";